module.exports = __webpack_public_path__ + "static/media/marker-courier2-empty.8dc841be.png";